import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import styled from "styled-components";

interface QRCardProps {
  url: string;
  logo: string;
}

const StyledQRCard = styled.div.attrs({ className: "QR" })`
  display: inline-block;
  border-radius: 5px;
  box-shadow: 0px 4px 4px 0px rgba(54, 56, 61, 0.2);
`;

const QRCard: React.FC<QRCardProps> = ({ url, logo }) => {
  return (
    <StyledQRCard>
      <QRCodeCanvas
        value={url}
        size={256}
        level={"H"}
        bgColor={"#ffffff"}
        fgColor={"#36383D"}
        includeMargin={true}
        imageSettings={{
          src: logo,
          x: undefined,
          y: undefined,
          height: 64,
          width: 64,
          excavate: true,
        }}
      />
    </StyledQRCard>
  );
};

export default QRCard;
